import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import * as styles from './GoogleAds.css';

const GoogleAds = (props) => {
    const { isNative } = useSelector(({ context = {} }) => context);
    return (
        !isNative && (
            <div
                id={props.adId}
                className={styles.adsBlock}
                data-automation-id={props.automationId}
            />
        )
    );
};

GoogleAds.defaultProps = {
    adId: '',
    automationId: 'ads-block',
};

GoogleAds.propTypes = {
    adId: PropTypes.string,
    automationId: PropTypes.string,
};

export default GoogleAds;
